
import { defineComponent, PropType } from 'vue';
import { IConditionInfo } from './types';

export default defineComponent({
  name: 'ConditionSelect',
  props: {
    conditionInfo: {
      type: Object as PropType<IConditionInfo>,
      default: () => ({}),
    },
    modelValue: {
      type: [String, Number],
    },
  },
  setup(props, { emit }) {
    return {
      handleChangeCondition(val: string | number) {
        emit('update:modelValue', val);
        emit('conditionChange', val);
      },
    };
  },
});
